import React from 'react';

import PropTypes from 'prop-types';

import { SvgIcon } from '@mui/material';

export const FontAwesomeSvgIcon = React.forwardRef((props, ref) => {
  /**
   * Accessibility infos: https://mui.com/material-ui/icons/#accessibility
   */
  const { icon, sx, ariaHidden=true, ariaLabel=null } = props;
  
  const {
    icon: [width, height, , , svgPathData],
  } = icon;
  
  const role = ariaHidden ? null: 'img';
  
  return (
    <SvgIcon aria-label={ariaLabel} aria-hidden={ariaHidden} role={role} ref={ref} viewBox={`0 0 ${width} ${height}`}  sx={sx ? sx : null}>
      {typeof svgPathData === 'string' ? (
        <path d={svgPathData} />
      ) : (
      /**
           * A multi-path Font Awesome icon seems to imply a duotune icon. The 0th path seems to
           * be the faded element (referred to as the "secondary" path in the Font Awesome docs)
           * of a duotone icon. 40% is the default opacity.
           *
           * @see https://fontawesome.com/how-to-use/on-the-web/styling/duotone-icons#changing-opacity
           */
        svgPathData.map((d, i, index) => (
          <path key={index} style={{ opacity: i === 0 ? 0.4 : 1 }} d={d} />
        ))
      )}
    </SvgIcon>
  );
});
  
FontAwesomeSvgIcon.propTypes = {
  icon: PropTypes.any.isRequired,
};

FontAwesomeSvgIcon.displayName = 'svgIcon';
